<template>
  <el-dropdown @visible-change="handleClick" trigger="click" placement="center">
    <div class="el-dropdown-link">
      <img src="../../../assets/img/001.png" alt="" v-if="hove == false" />
      <img src="../../../assets/img/002.png" alt="" v-else />
    </div>
    <el-dropdown-menu slot="dropdown" style="height:820rem">
      <div class="colorthree"></div>
      <div id="war">
        <img :src="getinfo.projectImg" alt="" />
      </div>
      <div class="box">
        <el-form
          :model="getinfo"
          :rules="rules"
          ref="getinfo"
          label-width="100px"
          class="demo-getinfo"
          :show-message="false"
        >
          <table class="table">
            <tr>
              <th>建筑名称：</th>
              <td v-if="isedit">
                <el-form-item label="" prop="buildingName">
                  <el-input
                    v-model="getinfo.buildingName"
                  ></el-input> </el-form-item
                ><img
                  src="../../../assets/img/save.png"
                  @click="submitForm('getinfo')"
                  alt=""
                  style="float:right; cursor: pointer;position: absolute; right: 1vw;top: 12px;"
                />
              </td>
              <td v-else>
                <div
                  style="display: inline-block;height: 40px;line-height:40px"
                >
                  {{ getinfo.buildingName }}
                </div>
                <i
                  class="el-icon-edit"
                  style="float:right; cursor: pointer;"
                  @click="isedit = true"
                ></i>
              </td>
            </tr>
            <tr>
              <th>建筑地址：</th>
              <td v-if="isedit">
                <el-form-item label="" prop="buildingAddress">
                  <el-input
                    type="textarea"
                    v-model="getinfo.buildingAddress"
                  ></el-input>
                </el-form-item>
              </td>
              <td v-else>{{ getinfo.buildingAddress }}</td>
            </tr>
            <tr>
              <th>建设年代：</th>
              <td v-if="isedit">
                <el-form-item label="" prop="constructionAge">
                  <el-input v-model="getinfo.constructionAge"></el-input>
                </el-form-item>
              </td>
              <td v-else>{{ getinfo.constructionAge }}</td>
            </tr>
            <tr>
              <th>建筑层数：</th>
              <td v-if="isedit">
                <el-form-item label="" prop="buildingFloors">
                  <el-input v-model="getinfo.buildingFloors"></el-input>
                </el-form-item>
              </td>
              <td v-else>{{ getinfo.buildingFloors }}</td>
            </tr>
            <tr>
              <th>建筑功能：</th>
              <td v-if="isedit">
                <el-form-item label="" prop="buildingFunction">
                  <el-input v-model="getinfo.buildingFunction"></el-input>
                </el-form-item>
              </td>
              <td v-else>{{ getinfo.buildingFunction }}</td>
            </tr>
            <tr>
              <th>建筑面积：</th>
              <td v-if="isedit">
                <el-form-item label="" prop="buildingArea">
                  <el-input v-model="getinfo.buildingArea"></el-input>
                </el-form-item>
              </td>
              <td v-else>{{ getinfo.buildingArea }}</td>
            </tr>
            <tr>
              <th>经济指标：</th>
              <td v-if="isedit">
                <el-form-item label="" prop="economicIndicators">
                  <el-input v-model="getinfo.economicIndicators"></el-input>
                </el-form-item>
              </td>
              <td v-else>{{ getinfo.economicIndicators }}</td>
            </tr>
          </table>
        </el-form>
      </div>
    </el-dropdown-menu>
  </el-dropdown>
</template>
<script>
import { chainIndex } from "../../../api/linkindex";
import { updateBuilding, GetProJectInfo } from "../../../api/common";
import { EnterpriseBackground } from "../../../api/backstageManagement";
import { play } from "../../../api/login";
export default {
  name: "Garden",
  props: {},
  data() {
    return {
      hove:false,
      getinfo: {},
      isedit: false,
      rules: {
        buildingName: [
          { required: true, message: "请输入建筑名称", trigger: "blur" },
        ],
        buildingAddress: [
          { required: true, message: "请输入建筑地址", trigger: "blur" },
        ],
        constructionAge: [
          { required: true, message: "请输入建设年代", trigger: "blur" },
        ],
        buildingFloors: [
          { required: true, message: "请输入建筑层数", trigger: "blur" },
        ],
        buildingFunction: [
          { required: true, message: "请输入建筑功能", trigger: "blur" },
        ],
        buildingArea: [
          { required: true, message: "请输入建筑面积", trigger: "blur" },
        ],
        economicIndicators: [
          { required: true, message: "请输入经济指标", trigger: "blur" },
        ],
      },
    };
  },
  watch: {},
  mounted() {
    this.GetProJectInfo();
  },
  methods: {
    //项目信息
    async GetProJectInfo() {
      let response = await GetProJectInfo();
      this.getinfo = response.data.data.project;
    },
    handleClick(t) {
      if (t) {
        this.hove = true;
      } else {
        this.hove = false;
      }
    },
    async submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let obj = {
            buildingAddress: this.getinfo.buildingAddress,
            buildingArea: this.getinfo.buildingArea,
            buildingFloors: this.getinfo.buildingFloors,
            buildingFunction: this.getinfo.buildingFunction,
            buildingName: this.getinfo.buildingName,
            constructionAge: this.getinfo.constructionAge,
            economicIndicators: this.getinfo.economicIndicators,
            projectId: this.$store.state.project.currentProject.projectId,
          };
          let response = await updateBuilding(obj);
          if (response.data.code == 200) {
            this.$message({
              message: '修改成功！',
              type: 'success'
            });
            this.isedit = false;
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.el-form-item {
  margin: 0;
}
/deep/.el-form-item__content {
  margin-left: 0 !important;
}
.box {
  margin: 0 20rem;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
}
.table {
  border-collapse: collapse;
  background: rgba(247, 249, 251, 1);
  font-size: 18rem;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dcdcdc;
  th,
  td {
    border: 1px solid #dcdcdc;
    font-weight: 500;
    position: relative;
  }
  th {
    width: 20%;
    height: 68rem;
  }
  td {
    padding: 0 14rem;
    text-align: left;
  }

  .el-input {
    width: 90%;
  }
  .el-textarea {
    width: 90%;
  }
  .el-textarea__inner {
    height: 40px;
  }
}
::v-deep .el-popper .popper__arrow {
  display: none !important;
}
.el-dropdown-menu {
  .w(528);
  .h(608);
  background: #ffffff;
  position: fixed !important;
  box-shadow: 0rem 4rem 40rem 0rem rgba(0, 43, 102, 0.28);
  left: 71.1% !important;
  top: 18% !important;
}
#war {
  padding: 10rem 20rem 10rem 20rem;
  height: 310rem;
  img {
    width: 100%;
    height: 100%;
  }
}
#site {
  font-size: 18rem;
  color: #333333;
  padding-left: 20rem;
  font-weight: 400;
  .site-one {
    display: flex;
    margin-bottom: 5rem;
    white-space: nowrap;
    .one-item {
      white-space: nowrap;
      width: 200rem;
      flex: 1;
      font-size: 18rem;
    }
    .one-item-net {
      white-space: nowrap;
      .w(359);
      padding-right: 10rem;
      flex: 4.5;
      font-size: 18rem;
    }
  }
}
#kong {
  border-bottom: 1rem solid #000000;
  opacity: 0.15;
}
#arr {
  padding: 13rem 0 0 24rem;
  background-color: #fff;
  padding-right: 30rem;
  .falx {
    margin-bottom: 10rem;
    display: flex;
    // white-space: nowrap;
    font-size: 18rem;
    color: #333333;
    // word-break:normal;
    // white-space:pre-warp;
    // word-wrap:break-word;
    // white-space: nowrap;
    p:first-child {
      display: flex;
      white-space: nowrap;
    }
    p:last-child {
      //  white-space: nowrap;
      display: flex;
      margin-left: 25rem;
    }
  }
}
::v-deep .el-dropdown-link:focus {
  outline: none;
}

.el-dropdown-link {
  // width: 20rem;
  // height: 20rem;
  cursor: pointer;
  position: relative;
  img {
    width: 22rem;
  }
  // left: 100%;
  // top: 2%;
}
.map {
  overflow: hidden;
  width: 100%;
  height: 100%;
  margin: 0;
  font-family: "微软雅黑";
}
.colorthree {
  position: absolute;
  width: 0;
  height: 0;
  border: 5rem solid;
  border-color: transparent transparent #fff;
  top: -10rem;
  left: 45%;
  margin-left: -12rem;
}
</style>
